export default __webpack_public_path__ + "static/media/icon_referrals.cbda2011.svg";